import { renderHeader } from './layouts/Header.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { ScenariosPage } from './pages/ScenariosPage.js';
import { SessionPage } from './pages/SessionPage.js';
import { StatsPage } from './pages/StatsPage.js';
import { ProfilePage } from './pages/ProfilePage.js';
import { AboutPage } from './pages/AboutPage.js';
import { applyLanguage } from './i18n/index.js';
import { applyTheme } from './hooks/useTheme.js';
import { getStoredLang, getStoredTheme } from './utils/storage.js';
import { EVENT, on, emit } from './utils/events.js';
import { installIconSprite } from './icons/index.js';

const pages = {
  dashboard: { el: DashboardPage, labelKey: 'navDashboard', icon: 'ic-chart' },
  scenarios: { el: ScenariosPage, labelKey: 'navScenarios', icon: 'ic-books' },
  session:   { el: SessionPage,   labelKey: '', icon: '' },
  stats:     { el: StatsPage,     labelKey: 'navStats',     icon: 'ic-trend' },
  profile:   { el: ProfilePage,   labelKey: 'navProfile',   icon: 'ic-user' },
  about:     { el: AboutPage,     labelKey: 'navAbout',     icon: 'ic-info' },
};

let activeTab = 'dashboard';

function renderActivePage(container) {
  container.innerHTML = '';
  container.appendChild(pages[activeTab].el());
}

export function mountApp(root) {
  root.innerHTML = '';

  // SVG sprite
  const sprite = document.createElement('div');
  sprite.id = 'svg-sprite';
  sprite.innerHTML = '<svg width="0" height="0" style="position:absolute"><defs id="sprite-defs"></defs></svg>';
  root.appendChild(sprite);
  installIconSprite(sprite.querySelector('#sprite-defs'));

  const header = document.createElement('div');
  header.id = 'app-header';
  root.appendChild(header);

  const main = document.createElement('main');
  main.className = 'wrap';
  main.id = 'app-main';
  root.appendChild(main);

  renderHeader(header, { pages, activeTab, onTabChange: (tab) => {
    if (!pages[tab]) return;
    activeTab = tab;
    renderActivePage(main);
    emit(EVENT.TAB_CHANGED, tab);
  }});

  renderActivePage(main);

  // Restore persisted preferences
  applyLanguage(getStoredLang() || 'ar');
  applyTheme(getStoredTheme() || 'system');

  // React to language changes (re-render everything so all strings update)
  on(EVENT.LANGUAGE_CHANGED, () => {
    renderHeader(header, { pages, activeTab, onTabChange: (tab) => {
      activeTab = tab;
      renderActivePage(main);
      emit(EVENT.TAB_CHANGED, tab);
    }});
    renderActivePage(main);
  });

  on(EVENT.TAB_REQUESTED, (tab) => {
    if (pages[tab]) {
      activeTab = tab;
      renderHeader(header, { pages, activeTab, onTabChange: (t) => emit(EVENT.TAB_REQUESTED, t) });
      renderActivePage(main);
    }
  });
}